import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    density: "comfortable",
    onClick: _ctx.toggleSpoilerStatus,
    icon: _ctx.iconName,
    variant: "plain",
    color: "text-primary"
  }, null, 8, ["onClick", "icon"]))
}